<template>
  <div v-if="provider" class="provider">
    <el-row>
      <el-col :span="4" class="avatar">
        <el-avatar
          :src="provider.profile.avatar | avatar128"
          icon="el-icon-user-solid"
        />
      </el-col>
      <el-col :span="15" class="details">
        <div class="name">
          {{ provider.profile.name }}
        </div>
        <div class="speciality">
          {{ provider.profile.service_type ? provider.profile.service_type.name : '' }}
        </div>
        <span class="rating">
          <span>{{ rating }} </span>
          <svg-icon
            v-for="n in 5"
            :key="n"
            name="star"
            :class="{selected: stars >= n}"
          />
        </span>
      </el-col>
    </el-row>

    <div class="dates">
      <div class="title">
        {{ $t('invoices.export') }}
      </div>
      <div class="date">
        <div class="label">
          {{ $t('from') }}
        </div>
        <el-date-picker
          v-model="form.date_from"
          format="dd MMMM yyyy"
          prefix-icon=""
          type="date"
          :placeholder="$t('pickDay')"
        />
      </div>
      <div class="date">
        <div class="label">
          {{ $t('to') }}
        </div>
        <el-date-picker
          v-model="form.date_to"
          format="dd MMMM yyyy"
          prefix-icon=""
          type="date"
          :placeholder="$t('pickDay')"
        />
      </div>
      <div class="commission">
        <div class="label">
          {{ $t('commission') }}
        </div>
        <el-input-number
          v-model="form.commission"
          :placeholder="$t('commission')"
        />
      </div>
    </div>

    <div class="buttons">
      <el-button type="warning" round @click="download">
        {{ $t('download') }}
      </el-button>
    </div>
  </div>
</template>

<script>
  import { exportInvoice } from '@/api/export'

  export default {
    props: {
      provider: Object
    },

    data() {
      return {
        form: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          date_from: '',
          // eslint-disable-next-line @typescript-eslint/camelcase
          date_to: '',
          commission: 10
        }
      }
    },

    computed: {
      rating() {
        return Math.round(this.provider.profile.average_rating * 10) / 10
      },

      stars() {
        return Math.round(this.provider.profile.average_rating)
      },

      avatar() {
        return this.provider.profile.avatar
          ? this.provider.profile.avatar.thumb_128
          : ''
      }
    },

    created() {
      const date = new Date()
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.form.date_from = new Date(date.getFullYear(), date.getMonth(), 1)
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.form.date_to = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    },

    methods: {
      download() {
        exportInvoice(this.getParams()).then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', this.fileName(response))
          document.body.appendChild(fileLink)
          fileLink.click()
        })
      },

      getParams() {
        return {
          // eslint-disable-next-line @typescript-eslint/camelcase
          service_provider_profile_id: this.provider.profile.id,
          // service_provider_profile_id: this.provider.profile.id,
          // eslint-disable-next-line @typescript-eslint/camelcase
          date_from: this.form.date_from.toISOString().slice(0, 10),
          // eslint-disable-next-line @typescript-eslint/camelcase
          date_to: this.form.date_to.toISOString().slice(0, 10),
          commission: this.form.commission
        }
      },

      fileName(response) {
        const disposition = response.headers['content-disposition']

        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/

          const matches = filenameRegex.exec(disposition)

          if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '')
          }
        }

        return 'invoice.pdf'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .provider {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 20px;
    left: 0;
    z-index: 500;

    .close {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      z-index: 600;

      .svg-icon {
        color: $color-text-darker;
      }
    }

    .avatar {
      min-width: 90px;
      color: white;
      padding-top: 2px;

      .el-avatar {
        width: 72px;
        height: 72px;
      }
    }

    .details {
      .name {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: $color-text-regular;
      }

      .speciality {
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        color: $color-text-placeholder;
      }

      .rating {
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: $color-text-regular;

        .svg-icon {
          fill: $menu-icon-color;
          color: $menu-icon-color;
          vertical-align: middle;
          width: 18px;
          height: 18px;
          margin-left: 3px;

          &.selected {
            fill: $color-warning;
            color: $color-warning;
          }
        }
      }
    }

    .dates {
      margin-top: 40px;

      .title {
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
      }

      .date {
        margin-top: 35px;

        .label {
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    .commission {
      margin-top: 35px;

      .label {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        padding-bottom: 7px;
      }
    }

    .buttons {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 60%;
    }
  }
</style>
